import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { AuthProvider } from './contexts/AuthContext';
import router from './routes';

function App() {
   return (
      <>
         <AuthProvider>
            <RouterProvider router={router} />
            <ToastContainer />
         </AuthProvider>
      </>
   );
}

export default App;
